@import '../variables.module.less';
@import '@/styles/mixins/index.less';
.favoriteButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: @v2-color-hover;
  border: 1px solid @v2-color-border;
  cursor: pointer;
  width: 48px;
  height: 48px;
  border-radius: 38px;
  position: relative;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
  color: @v2-color-secondary;
  padding: 0;

  svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  .heartIcon {
    transition:
      fill 0.2s ease,
      opacity 0.15s ease;
  }

  .heartIconHidden {
    opacity: 0;
  }

  .heartIconPopping {
    animation: like-pop 0.4s ease;
    transform-origin: center;
  }

  .heartReaction {
    position: absolute;
    width: 64px;
    height: 64px;
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  .heartReactionFinishing {
    opacity: 0;
  }

  .hover-supported({

    &:not(.disabled) {
      background: color-mix(in srgb, @v2-color-accent 12%, @v2-color-bg-white);
      color: @v2-color-accent;
      transform: scale(1.02);
  

    }

  });

  &:active:not(.disabled) {
    transform: scale(0.98);
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.favorited {
    background: var(--color-primary);
    border-color: var(--color-primary);
    color: var(--color-on-primary, #fff);

    svg {
      fill: var(--color-on-primary, #fff);
      stroke: var(--color-on-primary, #fff);
    }

    .hover-supported({

      &:not(.disabled) {
        background: color-mix(in srgb, var(--color-primary), black 12%);
        border-color: color-mix(in srgb, var(--color-primary), black 12%);
    

      }

    });
  }
}
